import { WORKFLOW_TYPES } from '../constants'

export const mockRequest = async () =>
  await new Promise(resolve => setTimeout(resolve, 1400))

// TODO: can be moved to /messaging.js once redux store circular dependency has been removed
export const handlePostMessage = (
  response,
  parentOrigin,
  object,
  type = null,
) => {
  const { payload, error } = response

  const messageData = {
    object,
    status: getStatus(type, error),
    data: error || payload,
  }

  console.log(messageData, type)
  window.parent.postMessage(messageData, parentOrigin)
}

const getStatus = (type, error) => {
  if (type) return type.toUpperCase()
  // support previous implementation defaults
  return error ? 'ERROR' : 'SUCCESS'
}

export const isCardCaptureWorkflowType = workflow =>
  workflow === WORKFLOW_TYPES.CARD_CAPTURE
export const isCheckoutWorkflowType = workflow =>
  workflow === WORKFLOW_TYPES.CHECKOUT

// These params should follow Artemis naming conventions (constants/errors.js)
export const buildError = (
  errorMessage,
  code = 'VALIDATION_ERROR',
  message = 'Validation error',
) => {
  return {
    message,
    details: [{ message: errorMessage, code }],
  }
}

// Artemis error shape: { code, message, errors: [{ details, field? }] } (not the
// `buildError` shape above). Artemis sets `field` only on validation messages it
// marks as user-facing (e.g. vendor address validation); every other error,
// including untagged VALIDATION_ERROR details, falls back to the generic message.
export const getBackendErrorMessage = (errorResponse, fallbackMessage) => {
  switch (errorResponse?.code) {
    case 'VALIDATION_ERROR': {
      const { details, field } = errorResponse.errors?.[0] ?? {}
      return field && details ? details : fallbackMessage
    }
    default:
      return fallbackMessage
  }
}

export const getFirstAndLastFromFullName = fullName => {
  const fullNameArr = fullName.split(' ')
  const firstName = fullNameArr.slice(0, -1).join(' ')
  const lastName = fullNameArr.slice(-1).join(' ')
  return { firstName, lastName }
}

export const getFormattedExpiration = (expMonth, expYear) =>
  `${expMonth}/${expYear.slice(-2)}`

export const getRoutingNumberForEFT = (transitNumber, institutionNumber) => {
  return `${institutionNumber}${transitNumber}`.padStart(9, '0')
}
